import React from "react";
import ReactDOM from "react-dom";
import "./assets/scss/index.scss";
import "./assets/scss/react-split-pane.scss";

import App from "./components/App.tsx";

ReactDOM.render(<App />, document.getElementById("root"));
